export const UNSCOPED_PERIOD_KEY = '__unassigned__';

export const getDraftPeriodId = (draft) => {
    const raw = draft?.period_id ?? draft?.periodId;
    if (raw === null || raw === undefined || raw === '') return null;
    return raw;
};

export const getDraftId = (draft) => {
    const raw = draft?.id;
    if (raw === null || raw === undefined || raw === '') return null;
    return raw;
};

export const getPeriodActiveDraftId = (period) => {
    const raw = period?.active_schedule_draft_id ?? period?.activeScheduleDraftId;
    if (raw === null || raw === undefined || raw === '') return null;
    return raw;
};

export const getPeriodKey = (periodId) => {
    if (periodId === null || periodId === undefined || periodId === '') return UNSCOPED_PERIOD_KEY;
    return String(periodId);
};

export const periodKeysEqual = (a, b) => getPeriodKey(a) === getPeriodKey(b);

export const draftMatchesPeriodKey = (draft, periodKey) => (
    getPeriodKey(getDraftPeriodId(draft)) === periodKey
);

export const isDraftLiveForPeriod = (draft, timePeriods = []) => {
    const draftId = getDraftId(draft);
    const periodId = getDraftPeriodId(draft);
    if (draftId == null || periodId == null) return false;
    const period = (timePeriods || []).find((item) => String(item.id) === String(periodId));
    const activeId = getPeriodActiveDraftId(period);
    return activeId != null && String(activeId) === String(draftId);
};

export const pickDraftNameForPeriod = (
    drafts,
    periodKey,
    preferredDraftName,
    avoidDraftName
) => {
    const inPeriod = (drafts || []).filter((draft) => draftMatchesPeriodKey(draft, periodKey));
    if (preferredDraftName && inPeriod.some((draft) => draft.draft_name === preferredDraftName)) {
        return preferredDraftName;
    }
    const avoided = inPeriod.find((draft) => draft.draft_name !== avoidDraftName);
    return avoided?.draft_name || inPeriod[0]?.draft_name || '';
};
